<template>
  <div class="menu-digital-view">
    <div v-if="supplier.id && supplier.on_table_class === 'checkout' && !getTableCodeInvalid">
      <v-progress-circular v-if="!seeForm" class="progress-circular" :size="70" color="cluvi2" indeterminate />
      <v-card v-if="!supplier.service_table">
        <v-card-text align="center" justify="center">
          <p>
            {{ $t("service.supplier.welcome_supplier_label", { name: instance.name }) }}
            {{ $t("service.supplier.on_table_no_service", { name: instance.name }) }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="center">
            <v-btn small rounded color="primary" dark>
              <v-icon dark left>fa-light fa-arrow-left</v-icon>
              <span v-html="$t('common.back_to_inicio_label')"></span>
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
      <div class="form-menu-digital" v-if="!is_ontable_service && seeForm && !joinOrderFlag">
        <p class="text-center">
          {{ $t("service.supplier.welcome_supplier_label", { name: instance.name }) }}
          {{ $t("menu-digital.menu_digital_label") }}
        </p>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-row align="center" justify="center" class="py-0">
            <v-col
              cols="12"
              align="center"
              justify="center"
              v-if="instance.on_table_form.allergic.active"
            >
              <h6 class="pr-8" v-html="$t('menu-digital.label_allergic')"></h6>
              <v-row justify="center" align="center">
                <v-col cols="4" md="2" class="pl-5 py-0">
                  <v-switch
                    v-model="isAllergic"
                    inset
                    :label="isAllergic ? 'Si' : 'No'"
                    color="blue"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="instance.on_table_form.allergic.active" cols="12" class="py-0">
              <v-text-field
                v-if="isAllergic"
                v-model="allergicText"
                :label="$t('menu-digital.how_label_allergic')"
                color="info"
                outlined
                :rules="instance.on_table_form.allergic.required? [rules.required]: []"
              />
            </v-col>
            <v-col v-if="instance.on_table_form.persons.active" cols="12" md="6" class="py-0">
              <v-text-field
                v-model="tablePersons"
                :label="$t('menu-digital.how_people_ontable')"
                type="number"
                color="info"
                :placeholder="$t('menu-digital.diners_label')"
                outlined
                :rules="instance.on_table_form.persons.required?[rules.required]:[]"
              />
            </v-col>
            <v-col v-if="instance.on_table_form.table.active" cols="12" md="6" class="py-0">
              <v-text-field
                v-model="tableIn"
                type="text" color="info" outlined
                :label="$t('order.on_table_label')"
                :rules="instance.on_table_form.table.required?[rules.required]:[]"
                :disabled="this.$route.query.mesa?true:false"
              />
            </v-col>
            <v-col v-if="instance.on_table_form.name.active" cols="12" md="6" class="py-0">
              <v-text-field
                v-model="profile.name"
                :label="$t('booking.booking_form_label')"
                outlined
                type="text"
                color="info"
                :rules="instance.on_table_form.name.required? [rules.required, rules.spaces, rules.letras]:[]"
              />
            </v-col>
            <v-col v-if="instance.on_table_form.phone.active" cols="12" md="6" class="py-0">
              <v-text-field
                v-model="profile.phone"
                :label="$t('checkout.buyer_phone_label')"
                type="number"
                color="info"
                outlined
                :rules="instance.on_table_form.phone.required? [rules.required,rules.spaces,rules.min.tel,rules.solonumeros]: []"
              />
            </v-col>
            <v-col v-if="instance.on_table_form.birthday_date.active" cols="12" md="6" class="py-0">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="profile.birthday_date"
                    v-bind="attrs"
                    v-on="on"
                    :label="$t('common.birthday_label')"
                    outlined
                    :rules="instance.on_table_form.birthday_date.required? [rules.required]: []"
                  />
                </template>
                <v-date-picker
                  v-model="profile.birthday_date"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                  no-title
                  ref="picker"
                  @change="saveBirthday()"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
        <p class="text-center">
          {{ $t("menu-digital.politics_label") }}
          <a @click="show_policies = !show_policies">{{ $t("service_policies.part_4") }}</a>
          {{ $t("service_policies.part_4") }}
        </p>
      </div>
      <join-order
        v-if="supplier.service_table && joinOrderFlag"
        @joinActiveRequest="joinActiveRequest"
      />
      <v-dialog v-model="show_policies" persistent max-width="500px" transition="dialog-transition">
        <service-policies-box @onClick="closeBox()" />
      </v-dialog>
      <v-footer app fixed v-if="supplier.service_table && seeForm &&  !joinOrderFlag ">
        <v-btn
          class="white--text" color="accent" rounded block
          v-html="$t('menu-digital.start_order_label')"
          @click="ValidateFormMenuDigital()"
        />
      </v-footer>
    </div>
    <div v-if="supplier.id && getTableCodeInvalid">
      <chip-error-msg :messagesError="messagesError" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { misMixins } from "@/mixins/mixins.js";
import { track } from "@/services/track-custom";
import { OnTableCart } from "@/services/OnTableCart";

export default {
  name: "OnTableMenuDigital",
  components: {
    ServicePoliciesBox: () => import(/* webpackChunkName: "servicePoliciesBox" */"@/components/legal/ServicePolicies"),
    JoinOrder: () => import(/* webpackChunkName: "joinOrder" */ "@/components/on_table/JoinOrder.vue"),
    ChipErrorMsg: () => import(/* webpackChunkName: "ChipErrorMsg" */ "@/components/share/ChipErrorMsg.vue")
  },
  data() {
    return {
      validateFormOnTable: false,
      valid: false,
      tableIn: "",
      tablePersons: 1,
      show_policies: false,
      validate: {
        name: false,
        persons: false,
        phone: false,
        tableIn: false,
        allergy: false,
        birthday_date: false
      },
      error: {
        name: false,
        persons: false,
        phone: false,
        tableIn: false,
        allergy: false,
        birthday_date: false
      },
      isAllergic: false,
      allergicText: "",
      menu: false,
      rules: {
        required: v => !!v || "Campo requerido",
        spaces: value => {
          const s = /^[^\s]+/;
          return s.test(value) || "Revisa espacio/os en blanco al iniciar...";
        },
        letras: value => {
          const letra = /(^[a-zA-ZÀ-ÿ\u00f1\u00d1]+)([\s]+)([^\s]+[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+)$/;
          return letra.test(value) || "Completa el campo";
        },
        solonumeros: value => {
          const soloNumeros = /^\d+$/;
          return soloNumeros.test(value) || "Número no valido...";
        },
        min: { tel: v => v.length >= 5 || "Número incorrecto" }
      },
      joinOrderFlag: false,
      backOrderId: null,
      seeForm: true,
      flatErrorService: false,
      messagesError: {
        msgLabel: this.$t("MODALALERTS.table_invalide", { mesa: this.$route.query.mesa })
      }
    };
  },
  async created() {
    this.setTableCodeInvalid(false);
    this.SetLoading(true);
    this.setMenuDigital();
    this.setTable();
    await this.GetSupplier(this.$route.params.supplier_id);
    this.TemplateActiveHeader({ header_type: "main" });
    this.SetAppClass("");
    this.ValidateHomeOnTableClass();
  },
  computed: {
    ...mapState("customer", ["instance", "supplier"]),
    ...mapState("profile", ["profile", "session"]),
    ...mapState("ontable", ["tableId"]),
    ...mapState("order", ["subservice", "otPurchaseId"]),
    ...mapGetters("order", ["is_ontable_service", "getTableCodeInvalid"]),
    ...mapGetters("customer", ["is_ontable_checkout", "is_ontable_plazoleta", "is_ontable_noincremental"])
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  mixins: [misMixins],
  methods: {
    ...mapActions("customer", ["GetSupplier"]),
    ...mapMutations("template", ["SwitchLeftPanel", "TemplateActiveHeader", "SetAppClass", "SetLoading"]),
    ...mapMutations("profile", ["SetProfile"]),
    ...mapMutations("ontable", ["setTableId", "setProductInCook", "setDisplayInfoOverlay", "setCountProductsOrdered"]),
    ...mapMutations("order", ["SetOtPurchaseId", "resetIdsProductsOnCart", "setTableCodeInvalid"]),
    ...mapActions("order", ["setMenuDigital"]),
    setTable() {
      if (this.$route.query.mesa) {
        this.tableIn = this.$route.query.mesa;
        this.setTableId(this.tableIn);
      } else {
        this.setTableId("");
      }
    },
    ValidateHomeOnTableClass() {
      if (this.is_ontable_checkout || this.is_ontable_noincremental) {
        if (this.otPurchaseId !== null) this.getActiveOrder();
        else this.returnOrder();
      } else if (this.is_ontable_plazoleta) {
        this.createPurchaseEmpty();
      } else {
        this.goHome();
      }

    },
    ValidateActiveForm() {
      if (this.is_ontable_service) {
        this.CheckAllForm();
      } else {
        if (
          !this.instance.on_table_form.allergic.active &&
          !this.instance.on_table_form.birthday_date.active &&
          !this.instance.on_table_form.name.active &&
          !this.instance.on_table_form.persons.active &&
          !this.instance.on_table_form.phone.active &&
          !this.instance.on_table_form.table.active
        ) {
          if (this.$route.query.mesa) this.tableIn = this.$route.query.mesa;
          else this.tableIn = "";
          this.seeForm = false;
          setTimeout(() => {
            this.CheckAllForm();
            this.seeForm = true;
          }, 2500);
        }

      }

    },
    async getActiveOrder() {
      this.SetLoading(true);
      this.setTableCodeInvalid(false);
      OnTableCart.validateActiveOrder().then(response => {
        if (response.data.active) {
          this.SetLoading(false);
          this.goHome();
        } else {
          this.returnOrder();
        }
      }).catch(error => {
        if (error.response.status === 422 && error.response.data.error === "table_code_invalid") {
          this.setTableCodeInvalid(true);
          this.SetLoading(false);
        } else if (error.response.status === 500 && error.response.data.error === "table_code_invalid") {
          this.setTableCodeInvalid(true);
          this.SetLoading(false);
        } else {
          this.returnOrder();
        }
      });


    },
    async returnOrder() {
      this.SetLoading(true);
      this.setTableCodeInvalid(false);
      OnTableCart.validateOrderOnTable().then(response => {
        this.SetLoading(false);
        this.setTable();
        if (response.data.purchase_id !== null) {
          this.joinOrderFlag = true;
          this.backOrderId = response.data.purchase_id;
        } else {
          this.ValidateActiveForm();
        }
      }).catch(error => {
        if (error.response.status === 422 && error.response.data.error === "table_code_invalid") {
          this.setTableCodeInvalid(true);
        } else if (error.response.status === 500 && error.response.data.error === "table_code_invalid") {
          this.setTableCodeInvalid(true);
        } else {
          this.ValidateActiveForm();
        }
      });
    },

    joinActiveRequest(opcion) {
      if (opcion === 0) {
        this.SetOtPurchaseId(this.backOrderId);
        OnTableCart.getProductsCart().then(response => {
          if (this.tableIn != response.table_code && response.table_code != null && response.table_code != "") {
            this.tableIn = response.table_code;
            this.setTableId(this.tableIn);
          }
          this.setCountProductsOrdered(response.purchase_product.length);
        });
        this.goHome();
      } else {
        this.joinOrderFlag = false;
        this.SetOtPurchaseId(null);
        this.ValidateActiveForm();
      }

    },
    ValidateFormMenuDigital() {
      if (this.is_ontable_checkout) {
        this.createPurchaseEmpty();
        return;
      }
      if (this.$refs.form.validate()) {
        this.CheckValidateName();
        if (this.isAllergic) this.CheckValidateAllergy();
        if (this.instance.on_table_form.persons.required) this.CheckValidatePersons();
        if (this.instance.on_table_form.table.required) this.CheckValidateTableIdIn();
        if (this.instance.on_table_form.phone.required) this.CheckValidatePhone();
        if (this.instance.on_table_form.birthday_date.required) this.CheckValidateBirthdayDate();
      }

    },
    CheckAllForm() {
      this.validateFormOnTable = false;
      if (this.error.allergy) return;
      if (this.error.persons) return;
      if (this.error.tableIn) return;
      if (this.error.name) return;
      if (this.error.phone) return;
      if (this.error.birthday_date) return;
      this.validateFormOnTable = true;
      this.checkStep1();
    },
    CheckValidateAllergy() {
      if (this.instance.on_table_form.allergic.required) {
        this.validate.allergy = false;
        this.error.allergy = false;
        if (
          this.isAllergic &&
          this.allergicText !== undefined &&
          this.allergicText.toString().length > 0
        )
          this.validate.allergy = true;
        else this.error.allergy = true;
      } else {
        this.validate.allergy = false;
        this.error.allergy = false;
        if (this.isAllergic) this.validate.allergy = true;
        else this.error.allergy = true;
      }
    },
    CheckValidatePersons() {
      this.validate.persons = false;
      this.error.persons = false;
      if (this.tablePersons !== undefined && this.tablePersons > 0)
        this.validate.persons = true;
      else this.error.persons = true;
    },
    CheckValidateTableIdIn() {
      this.validate.tableIn = false;
      this.error.tableIn = false;
      if (this.tableIn !== undefined && this.tableIn.toString().length > 0)
        this.validate.tableIn = true;
      else this.error.tableIn = true;
    },
    CheckValidateName() {
      this.validate.name = false;
      this.error.name = false;
      if (
        this.profile.name === null ||
        this.profile.name.length === 0 ||
        /^\s+$/.test(this.profile.name)
      ) {
        this.error.profileName = true;
      } else {
        let name = this.profile.name.trim().replace(/\s\s+/g, " ").split(" ", 2);
        if (
          name &&
          name.length === 2 &&
          name[0] !== "undefined" &&
          name[0].length > 0 &&
          name[1] !== "undefined" &&
          name[1].length > 0
        ) this.validate.name = true;
        else this.error.name = true;
      }

      this.CheckAllForm();
    },
    CheckValidatePhone() {
      this.validate.phone = false;
      this.error.phone = false;
      if (
        this.profile.phone === null ||
        this.profile.phone.length === 0 ||
        /^\s+$/.test(this.profile.phone)
      ) {
        this.error.profilePhone = true;
      } else {
        let number = Number(this.profile.phone);
        if (this.profile.phone.length >= 5 && number) {
          this.validate.phone = true;
        } else {
          this.error.phone = true;
        }
      }
    },
    CheckValidateBirthdayDate() {
      this.validate.birthday_date = false;
      this.error.birthday_date = false;
      if (
        this.profile.birthday_date &&
        this.profile.birthday_date.toString().length > 0
      ) {
        this.validate.birthday_date = true;
      } else {
        this.error.birthday_date = true;
      }
    },
    saveBirthday(date) {
      this.$refs.menu.save(date);
      this.$refs.picker.activePicker = "YEAR";
      this.menu = false;
    },
    checkStep1() {
      if (this.validateFormOnTable === true) {
        this.setTableId(this.tableIn);
        this.checkStep2();
      }

    },
    checkStep2() {
      this.SetProfile({
        name: this.profile.name,
        phone: this.profile.phone,
        birthday_date: this.profile.birthday_date,
        phone_code: this.profile.phone_code
      });
      this.createPurchaseEmpty();
    },
    async createPurchaseEmpty() {
      this.SetLoading(true);
      const data = {
        buyer_name: this.profile.name,
        buyer_phone: this.profile.phone,
        table_persones: this.tablePersons,
        table_code: this.tableIn,
        is_allergy: this.isAllergic,
        supplier_id: this.supplier.id,
        session_id: this.session.id
      };
      if (this.isAllergic) data.allergy_description = this.allergicText;
      this.validateProfile();
      this.getDatesTimeout = setTimeout(() => {
        OnTableCart.createPurchaseEmpty(data)
          .then(response => {
            this.setTableCodeInvalid(false);
            this.SetOtPurchaseId(response.data.id);
            this.setProductInCook(false);
            this.setCountProductsOrdered(0);
            this.resetIdsProductsOnCart([]);
            if (this.is_ontable_checkout || this.is_ontable_plazoleta) this.setDisplayInfoOverlay(true);
            if(this.instance.slug == 'baham') this.setDisplayInfoOverlay(false);
            this.goHome();
          })
          .catch(error => {
            if (error.response.status === 422 && error.response.data.error === "table_code_invalid") {
              this.setTableCodeInvalid(true);
            } else if (error.response.status === 500 && error.response.data.error === "table_code_invalid") {
              this.setTableCodeInvalid(true);
            }
            this.SetLoading(false);
          });
      }, 1000);
    },
    goHome() {
      if(this.instance.cluvi_add_ons.includes('newhome')){
        this.$router.push({
            name: "OnTableNewHome",
            params: {supplier_id: this.supplier.slug}
          });
      }else{
        this.$router.push({
          name: "OnTableHome",
          params: { supplier_id: this.$route.params.supplier_id }
        });
      }
    },
    closeBox() {
      this.show_policies = false;
    }
  },
  mounted() {
    setTimeout(() => {
    }, process.env.VUE_APP_DELAY);
    track.trackView(this, `Formulario Menu en mesa`, `/menu-digital`);
    track.trackEventCluvi({}, "view form menu en mesa");
  },
  metaInfo() {
    return {
      title: `Menú Digital | ${this.supplier.label}`
    };
  }
};
</script>


<style scoped>
.progress-circular {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  margin: auto;
}
</style>
